import { render, staticRenderFns } from "./Grid4.vue?vue&type=template&id=874deca6"
import script from "./Grid4.vue?vue&type=script&lang=js"
export * from "./Grid4.vue?vue&type=script&lang=js"
import style0 from "./Grid4.vue?vue&type=style&index=0&id=874deca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports